import { providerLogoutUrl } from '../api/client';
import { isMockMode } from '../dev/mode';
import { useSession } from './SessionContext';

export type LoginScreenKind = 'unauthenticated' | 'loggedout' | 'error';

/** Closed vocabulary of the API's `?login_error=` reasons. */
const LOGIN_ERRORS: Record<string, string> = {
  not_authorized: 'Ez a fiók nincs engedélyezve: a felület csak a tulajdonosnak érhető el.',
  provider_error: 'A bejelentkezési szolgáltató hibát jelzett vagy megszakadt a belépés.',
  state_mismatch: 'A belépési folyamat nem egyezett (lejárt vagy megismételt kérés). Próbáld újra.',
  missing_login_state: 'A belépési folyamat lejárt (hiányzó süti). Próbáld újra.',
  invalid_login_state: 'A belépési folyamat lejárt vagy érvénytelen. Próbáld újra.',
  token_exchange_failed: 'A belépés befejezése nem sikerült a szolgáltatónál. Próbáld újra.',
  invalid_id_token: 'A szolgáltató azonosító tokenje nem érvényes. Próbáld újra.',
  login_not_configured: 'A bejelentkezés ezen a telepítésen nincs beállítva.',
};

export function LoginScreen({ kind, loginError, message }: { kind: LoginScreenKind; loginError?: string | null; message?: string }) {
  const { login, retry } = useSession();
  return (
    <main className="page" style={{ maxWidth: 560, margin: '48px auto' }}>
      <div className="card">
        <h1>MoneyFlow</h1>
        {kind === 'error' ? (
          <>
            <div className="notice err" role="alert">
              <b>A munkamenet nem ellenőrizhető</b>
              <div className="small">Az API nem válaszolt a bejelentkezés ellenőrzésére.{message ? ` (${message})` : ''}</div>
            </div>
            <button type="button" className="btn" onClick={retry}>
              Újrapróbálom
            </button>
          </>
        ) : (
          <>
            {loginError ? (
              <div className="notice err" role="alert">
                <b>A belépés nem sikerült</b>
                <div className="small">
                  {LOGIN_ERRORS[loginError] ?? 'Ismeretlen hiba.'} <span className="mono">({loginError})</span>
                </div>
              </div>
            ) : null}
            {loginError === 'not_authorized' && !isMockMode() ? (
              <p className="small">
                Másik fiókkal próbálkoznál? <a href={providerLogoutUrl()}>Kilépés a bejelentkezési szolgáltatónál</a>, utána újra beléphetsz.
              </p>
            ) : null}
            <p className="muted">{kind === 'loggedout' ? 'Kiléptél. A belépéshez add meg újra az adataidat.' : 'A belépés szükséges.'}</p>
            <button type="button" className="btn primary" onClick={login}>
              Belépés
            </button>
          </>
        )}
      </div>
    </main>
  );
}
